import * as React from 'react';
import * as styles from './Services.css';
import { Slider } from '../../../common/Slider';
import { SLIDE_WIDTH } from './constants';
import { SERVICES_SLIDER_ID } from '../../../../constants/nodeIds';
import { EServiceId } from '../../../../redux/reducers';
import { CommonServiceContainer } from '../CommonService';
import { getSliderIndents } from './utils/getSliderIndents';

export interface IServicesProps {
  isMobile: boolean;
  isBetPositionVisible: boolean;
  serviceIds: EServiceId[];
  activeServiceIndex: number | undefined;
  onScrollSliderRight(): void;
  onScrollSliderLeft(): void;
}

export const Services = (props: IServicesProps) => {
  const { isMobile, isBetPositionVisible, serviceIds, activeServiceIndex, onScrollSliderRight, onScrollSliderLeft } =
    props;

  const services = serviceIds.map(serviceId => <CommonServiceContainer key={serviceId} serviceId={serviceId} />);

  const indents = getSliderIndents({ isMobile, isBetPositionVisible });

  return (
    <div className={styles['services']}>
      <Slider
        id={SERVICES_SLIDER_ID}
        initialSlide={activeServiceIndex}
        visibleSlides={3}
        additionalOffset={42}
        slideWidth={SLIDE_WIDTH}
        indents={indents}
        onScrollLeft={onScrollSliderLeft}
        onScrollRight={onScrollSliderRight}
      >
        {services}
      </Slider>
    </div>
  );
};
